import React, { useEffect, useRef } from "react";
import "./styles.scss";
import { GetMisReportData } from "./tenantApiCalls";
import { iDropdown } from ".";
import { summaryReport, misReport } from "./interfaces";
import { FormatFullDate } from "../../Logic/DateTimeFormatters";
import { getSessionValue } from "../../utilities/localStore/calls";
import Processing from "../Generic/Processing";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { RootState } from "../../state/store";
import { useSelector } from "react-redux";

function MisReport(props: summaryReport) {
    const [misData, setData] = React.useState<misReport[] | undefined>(undefined);
    const reportTable = useRef<HTMLTableElement>(null);
    const [reportData, setReportData] = React.useState<{
        dateFrom: string;
        dateTo: string;
    }>({
        dateFrom: "",
        dateTo: "",
    });
    useEffect(() => {
        (async () => {
            if (props.generateReport) {
                const result = await GetMisReportData(props);
                if (result.isOk && result.data) {
                    let data = result.data.results;
                    setData(data);
                }
                const diffInMs =
                    new Date(new Date(props.dateTo.toString()).toDateString()).valueOf() -
                    new Date(new Date(props.dateFrom.toString()).toDateString()).valueOf();
                const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

                setReportData({
                    dateFrom: props.dateFrom.toString(),
                    dateTo: props.dateTo.toString(),
                });
            }
        })();
    }, [props.generateReport]);

    const downloadReport = () => {
        if (reportTable.current) {
            const workbook = XLSX.utils.table_to_book(reportTable.current);

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const data = new Blob([excelBuffer], { type: "application/octet-stream" });
            const fileName = "MIS_Report_" + Date.now();
            saveAs(data, `${fileName}.xlsx`);
        }
    };
    return (
        <>
            {misData == undefined && props.primaryFieldKey !== undefined && props.generateReport == true && (
                <Processing>
                    {" "}
                    <p>
                        Getting Report Data
                        <br />
                        Please wait...
                    </p>
                </Processing>
            )}
            {misData != undefined && (
                <div className="reportPadding">
                    <div>
                        <div style={{ textAlign: "right", paddingBottom: "7px" }}>
                            <button
                                className="g-btn g-btn-action"
                                onClick={downloadReport}
                            >
                                {" "}
                                Download Report
                            </button>{" "}
                        </div>
                        <table
                            className="reportTable"
                            ref={reportTable}
                        >
                            <thead>
                                <tr>
                                    <th
                                        style={{ width: "50%", fontSize: "14px", border: "0px" }}
                                        colSpan={8}
                                    >
                                        MIS On Screen Report
                                    </th>
                                    <th
                                        colSpan={7}
                                        rowSpan={2}
                                        className="right"
                                    >
                                        From: {FormatFullDate(reportData.dateFrom)}
                                        <br />
                                        To: {FormatFullDate(reportData.dateTo)}
                                    </th>
                                </tr>
                                <tr>
                                    <th
                                        style={{ border: "0px" }}
                                        colSpan={8}
                                    ></th>
                                </tr>
                                <tr className="greyRow">
                                    <td
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        {props.primaryFieldKey?.fieldLabel}
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Completed <br /> Delegated
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Completed <br /> No response
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Completed <br /> Reassigned
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Completed <br /> Responded
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Pending
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Pending Correspond <br />
                                        with Enquirer
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Pending <br />
                                        Escalation
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Pending <br /> RIF
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Has New <br />
                                        Message
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Received
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        User <br />
                                        Processing
                                    </td>
                                    <td
                                        rowSpan={1}
                                        className="center"
                                        style={{ borderLeft: "solid 1px #aaa" }}
                                    >
                                        Grand Total
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {misData?.map((x, index) => {
                                    return (
                                        <>
                                            <tr
                                                style={{
                                                    background: index % 2 === 0 ? "#fff" : "#f3f3f3",
                                                }}
                                            >
                                                <td style={{ borderLeft: "solid 1px #aaa" }}>{x.FieldValue}</td>
                                                <td className="right">{x["Completed - Forwarded"]}</td>
                                                <td className="right">{x["Completed - No response"]}</td>
                                                <td className="right">{x["Completed - Reassigned"]}</td>
                                                <td className="right">{x["Completed - Responded"]}</td>
                                                <td className="right">{x["Pending - General"]}</td>
                                                <td className="right">{x["Pending - Correspond with Enquirer"]}</td>
                                                <td className="right">{x["Pending - Escalated"]}</td>
                                                <td className="right">{x["Pending - Request Internal Feedback"]}</td>
                                                <td className="right">{x["Has New Message"]}</td>
                                                <td className="right">{x.Received}</td>
                                                <td className="right">{x["User Processing"]}</td>
                                                <td className="right">
                                                    {x["Completed - Forwarded"] +
                                                        x["Completed - No response"] +
                                                        x["Completed - Reassigned"] +
                                                        x["Completed - Responded"] +
                                                        x["Pending - General"] +
                                                        x["Pending - Correspond with Enquirer"] +
                                                        x["Pending - Escalated"] +
                                                        x["Pending - Request Internal Feedback"] +
                                                        x["Has New Message"] +
                                                        x.Received +
                                                        x["User Processing"]}
                                                </td>
                                            </tr>
                                        </>
                                    );
                                })}
                                {misData && (
                                    <tr style={{ fontWeight: "bold", background: "#ddd" }}>
                                        <td style={{ borderLeft: "solid 1px #aaa" }}>Grand Total</td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x["Completed - Forwarded"]), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x["Completed - No response"]), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x["Completed - Reassigned"]), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x["Completed - Responded"]), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x["Pending - General"]), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce(
                                                (sum, x) => sum + Number(x["Pending - Correspond with Enquirer"]),
                                                0,
                                            )}
                                        </td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x["Pending - Escalated"]), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce(
                                                (sum, x) => sum + Number(x["Pending - Request Internal Feedback"]),
                                                0,
                                            )}
                                        </td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x["Has New Message"]), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x.Received), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce((sum, x) => sum + Number(x["User Processing"]), 0)}
                                        </td>
                                        <td className="right">
                                            {misData.reduce(
                                                (sum, x) =>
                                                    sum +
                                                    Number(x["Completed - Forwarded"]) +
                                                    Number(x["Completed - No response"]) +
                                                    Number(x["Completed - Reassigned"]) +
                                                    Number(x["Completed - Responded"]) +
                                                    Number(x["Pending - General"]) +
                                                    Number(x["Pending - Correspond with Enquirer"]) +
                                                    Number(x["Pending - Escalated"]) +
                                                    Number(x["Pending - Request Internal Feedback"]) +
                                                    Number(x["Has New Message"]) +
                                                    Number(x.Received + Number(x["User Processing"])),
                                                0,
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
}
export default MisReport;
